<script setup lang="ts">
import { defineComponent,reactive } from 'vue'
import { ElMenu,ElMenuItem,ElMenuItemGroup,ElSubMenu, ElIcon,ElRadioGroup,ElRadioButton, ElScrollbar, type MenuItemClicked } from 'element-plus'
import router from '@/router'
import { gotoURL } from '@/utils/mfk'

interface IMenuItem{
  path: string,
  name: string,
  title: string,
  icon: string,
  isChild: boolean,
  redirect: string,
  children: IMenuItem[]
}
const markMenuItem = (item : any)=>{
  if(item.meta && item.meta.hidden){
    return undefined
  }
  let menuItem:IMenuItem ={
    path: item.path,
    name: item.name?item.name:'',
    title: '',
    icon: '',
    isChild:false,
    redirect: item.redirect?item.redirect:'',
    children:[]
  }
  if(item.meta){
    if(item.meta.title){
      menuItem.title = item.meta.title
    }
    if(item.meta.icon){
      menuItem.icon = item.meta.icon
    }
  }
  if(item.children && item.children.length>0){
    for(let subItem of item.children){
      let subMenuItem=markMenuItem(subItem)
      if(subMenuItem){
        menuItem.children.push(subMenuItem)
      }
    }
  }
  
  menuItem.isChild = menuItem.children.length>0
  
  return menuItem
}
const MarkMenuList = (router:any)=>{
  let list:IMenuItem[] = []
  for(let item of router.options.routes){
  let menuItem=markMenuItem(item)
  if(menuItem){
    list.push(menuItem)
  }
}
return list
}
const menuList:IMenuItem[] = reactive<IMenuItem[]>(MarkMenuList(router))

const props = defineProps({
    isCollapse: {
    type: Boolean,
    default: false
  }
})
const handleMenuItemSelect = (param:IMenuItem) => {
  if(param.isChild){
    return
  }
  let path=param.redirect?param.redirect:param.path

  gotoURL(path)
}

</script>
<template>
  <ElScrollbar>
    <el-menu
    class="el-menu-open"
    :collapse="isCollapse"
    :default-active="$route.path"
  >
  <component v-for="(item,index) in menuList"  :is="item.isChild?ElSubMenu:(isCollapse?ElSubMenu:ElMenuItem)"
  :key="item.name"
  :index="item.path" 
  :route="item.path"
  @click="handleMenuItemSelect(item)"
  >
      <template #title>
        <el-icon v-if="item.icon">
          <component :is="item.icon" />
        </el-icon>
        <span>{{ item.title }}</span>
      </template>
      <el-menu-item v-if="item.isChild" v-for="(subItem,subInd) in item.children" 
      :key="subItem.name" 
      :index="subItem.path" 
      :route="subItem.path"
      @click="handleMenuItemSelect(subItem)"
      >
        <template #title>
          <el-icon v-if="subItem.icon">
          <component :is="subItem.icon" />
        </el-icon>
        <span>{{ subItem.title }}</span>
      </template>
      </el-menu-item>
  </component>
  </el-menu>
</ElScrollbar>
</template>
<style>
.el-menu-open {
  height: 100%;
}
.el-menu-open:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.submenu-title-noDropdown {
      padding: 0 !important;
      position: relative;

      .el-tooltip {
        padding: 0 !important;

        .svg-icon {
          margin-left: 20px;
        }
      }
    }
</style>